import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";

type Input = { step?: string; name?: string };
type Output = { ok?: boolean; name?: string };

function PinStepTestHeader({ toolUse, result, interrupted }: ToolUseProps) {
  const input = toolUse.input as Input | null;
  const output = result?.output as Output | undefined;
  const done = !!result && !result.isError;
  const name = output?.name ?? input?.name;

  const text = !done
    ? `Adding step test${input?.step ? ` for ${input.step}` : ""}…`
    : output?.ok === false
      ? "Couldn’t add step test"
      : name
        ? `Added step test ${name}`
        : "Added step test";

  return (
    <ToolStatus icon="microscope" text={text} pending={!done && !interrupted} />
  );
}

export const pinStepTest: ChatTool = {
  name: "pinStepTest",
  Header: PinStepTestHeader,
};
